export type SurfBreakDirection = 'left' | 'right';

// Dominant named breaks, from the surfer's perspective. Sources and scope are
// recorded in docs/features/conditions-visualiser.md. Do not copy the legacy
// directory direction column: its original seed reverses several of these.
export const SURF_BREAK_DIRECTIONS: Readonly<Record<string, SurfBreakDirection>> = {
  uluwatu: 'left',
  'padang-padang': 'left',
  raglan: 'left',
  noosa: 'right',
  angourie: 'right',
  'lennox-head': 'right',
  'jeffreys-bay': 'right',
};

/** Unknown and mixed beach breaks keep a consistent illustrative direction. */
export function surfBreakDirection(location: { slug: string; breakDirection?: SurfBreakDirection }): SurfBreakDirection {
  return location.breakDirection ?? SURF_BREAK_DIRECTIONS[location.slug] ?? 'left';
}
